import { Dispatch } from 'react-redux';

import * as types from "./action-types";
import { AuthActionCreators, IApplicationState } from '../../index';
import { Utility } from '../../../services/utility';
import {
    IQaRegistrationGetRegistrationStepsResponse, IQaRegistrationRegistrationStep, IQaRegistrationSetRegistrationStepResponse,
    IQaRegistrationGetCentersResponse, IQaRegistrationGetRegistrationResponse, IQaRegistrationCreateRegistrationResponse,
    ICenter, IRegistration
} from '../../../models/index';
import { RegistrationStep, QaRegistrationFormState } from '../../../enums/index'

export const ActionCreators = {
    getCenters: () => (dispatch: Dispatch<IApplicationState>): Promise<IQaRegistrationGetCentersResponse> => {
        var options = {
            url: __API__ + "/qa/getcenters"
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IQaRegistrationGetCentersResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setGetCenters(response.data.results));

            return Promise.resolve(response);
        });
    },
    getRegistrationSteps: () => (dispatch: Dispatch<IApplicationState>): Promise<IQaRegistrationGetRegistrationStepsResponse> => {
        var options = {
            url: __API__ + "/qa/getregistrationsteps"
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IQaRegistrationGetRegistrationStepsResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setGetRegistrationSteps(response.data.results));

            return Promise.resolve(response);
        });
    },
    getPwlSteps: () => (dispatch: Dispatch<IApplicationState>): Promise<IQaRegistrationGetRegistrationStepsResponse> => {
        var options = {
            url: __API__ + "/qa/getpwlsteps"
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IQaRegistrationGetRegistrationStepsResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setGetRegistrationSteps(response.data.results));

            return Promise.resolve(response);
        });

    },
    getRegistration: (id:number, editkey:string) => (dispatch: Dispatch<IApplicationState>): Promise<IQaRegistrationGetRegistrationResponse> => {
        var options = {
            url: __API__ + "/qa/getregistration/" + id + "/"  + editkey
        }

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IQaRegistrationGetRegistrationResponse) => {
            //if (response.data.success)
            //    dispatch(ActionCreators.setGetCenters(response.data.results));

            return Promise.resolve(response);
        });
    },
    setRegistrationStep: (registrationStep: RegistrationStep, id: number, editKey: string, formState: QaRegistrationFormState) => (dispatch: Dispatch<IApplicationState>): Promise<IQaRegistrationSetRegistrationStepResponse> => {
        var options = {
            url: __API__ + "/qa/setregistrationstep",
            data: {
                registrationStep: registrationStep,
                editKey: editKey,
                id: id,
                formState: formState
            }
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IQaRegistrationSetRegistrationStepResponse) => {
            if (response.data.success) {
                //dispatch(ActionCreators.setAdpPrint(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    setCreateRegistration: (registration: IRegistration, url:string) => (dispatch: Dispatch<IApplicationState>): Promise<IQaRegistrationCreateRegistrationResponse> => {
        var options = {
            url: __API__ + "/qa/createregistration",
            data: {
                registration: registration,
                url: url
            }
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IQaRegistrationCreateRegistrationResponse) => {
            if (response.data.success) {
                //dispatch(ActionCreators.setAdpPrint(response.data.results));
            }

            return Promise.resolve(response);
        });
    },
    setGetRegistrationSteps: (list: IQaRegistrationRegistrationStep[]) => {
        return {
            type: types.SET_GETREGISTRATIONSTEPS,
            list
        }
    },
    setGetCenters: (list: ICenter[]) => {
        return {
            type: types.SET_GETCENTERS,
            list
        }
    }


}